export const compareStringifiedObjects = (a: any, b: any) => JSON.stringify(a) === JSON.stringify(b);
